import React, { useMemo } from 'react';
import { createPortal } from 'react-dom';

const COLORS = ['#e63946', '#14142b', '#ffd166', '#ffffff'];
const PIECE_COUNT = 48;

const Confetti = () => {
    const pieces = useMemo(() => (
        Array.from({ length: PIECE_COUNT }, (_, i) => ({
            key: i,
            left: Math.random() * 100,
            delay: Math.random() * 450,
            duration: 1800 + Math.random() * 1600,
            color: COLORS[Math.floor(Math.random() * COLORS.length)],
            width: 6 + Math.random() * 6,
            height: 10 + Math.random() * 8,
        }))
    ), []);

    if (typeof document === 'undefined') return null;

    return createPortal(
        <div className="fixed inset-0 z-[1001] pointer-events-none overflow-hidden" aria-hidden="true">
            {pieces.map(p => (
                <div
                    key={p.key}
                    className="confetti-piece"
                    style={{
                        left: `${p.left}%`,
                        width: `${p.width}px`,
                        height: `${p.height}px`,
                        backgroundColor: p.color,
                        animationDelay: `${p.delay}ms`,
                        animationDuration: `${p.duration}ms`,
                    }}
                />
            ))}
        </div>,
        document.body,
    );
};

export default Confetti;
